import React from "react";
import { motion } from "framer-motion";
import ScrollAnimation from "../../hooks/ScrollAnimation";
export default function ServicesFaqSection() {
  return (
    <section className="py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollAnimation direction="up" delay={0.1}>
          <div className="text-center mb-16">
            <motion.h2
              className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.6 }}
            >
              Frequently Asked Questions
            </motion.h2>
            <motion.p
              className="text-lg text-gray-600"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.6 }}
            >
              Common questions about our immigration services.
            </motion.p>
          </div>
        </ScrollAnimation>

        <div className="space-y-6">
          <ScrollAnimation direction="up" delay={0.1}>
            <motion.div
              className="bg-white border border-gray-200 rounded-lg p-6"
              whileHover={{ scale: 1.02, y: -2 }}
              transition={{ duration: 0.3 }}
            >
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                How much do your immigration services cost?
              </h3>
              <p className="text-gray-600">
                Our pricing varies by service type. Basic form assistance starts
                at affordable rates with transparent pricing. Lawyer
                consultation fees are set by individual attorneys. We offer
                flexible payment plans to make immigration services accessible.
              </p>
            </motion.div>
          </ScrollAnimation>

          <ScrollAnimation direction="up" delay={0.2}>
            <motion.div
              className="bg-white border border-gray-200 rounded-lg p-6"
              whileHover={{ scale: 1.02, y: -2 }}
              transition={{ duration: 0.3 }}
            >
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                How quickly can you process my immigration forms?
              </h3>
              <p className="text-gray-600">
                With our step-by-step guidance, you can complete most
                immigration forms within hours. Document review typically takes
                24-48 hours, and we'll help ensure everything is accurate before
                submission to USCIS.
              </p>
            </motion.div>
          </ScrollAnimation>

          <ScrollAnimation direction="up" delay={0.3}>
            <motion.div
              className="bg-white border border-gray-200 rounded-lg p-6"
              whileHover={{ scale: 1.02, y: -2 }}
              transition={{ duration: 0.3 }}
            >
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                What information do I need to provide?
              </h3>
              <p className="text-gray-600">
                We'll need basic information about your immigration case, your
                current status, and your goals. We'll guide you through what
                documents are needed and help you gather everything required for
                your specific case type.
              </p>
            </motion.div>
          </ScrollAnimation>

          <ScrollAnimation direction="up" delay={0.4}>
            <motion.div
              className="bg-white border border-gray-200 rounded-lg p-6"
              whileHover={{ scale: 1.02, y: -2 }}
              transition={{ duration: 0.3 }}
            >
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Do you offer payment plans?
              </h3>
              <p className="text-gray-600">
                Yes, we understand that immigration services can be costly. We
                work with clients to create flexible payment plans that fit
                their budget. Payment options vary by service type and can be
                discussed during your initial consultation.
              </p>
            </motion.div>
          </ScrollAnimation>
        </div>
      </div>
    </section>
  );
}
